import { z } from "zod";

import { CurrencySchema } from "api/schemas/shared";

const SharedArgsSchema = z.object({
  params: z.object({
    start_time: z.string(),
  }),
});
export type SharedArgs = z.infer<typeof SharedArgsSchema>;

export const GetTherapistRatingResponseSchema = z.object({
  rating: z.number(),
});

const PatientsFunctionalitySchema = z.object({ avg_functionality: z.number(), week_number: z.number() });
export type PatientsFunctionality = z.infer<typeof PatientsFunctionalitySchema>;

export const GetTherapistPatientsFunctionalitySchema = z.object({
  items: z.array(PatientsFunctionalitySchema),
});

export const GetTherapistPatientsPainSchema = z.object({
  items: z.array(
    z.object({
      avg_pain: z.number(),
      week_number: z.number(),
    })
  ),
});

export const GetTherapistEnrollmentsResponseSchema = z.object({
  enrollment_goal: z.number(),
  patients_enrolled: z.number(),
});

export const GetTherapistCommissionsResponseSchema = z.object({
  currency: CurrencySchema,
  items: z.record(z.string(), z.record(z.string(), z.number())),
});
